 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"main": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + "997da4fc" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01491e7a":1,"chunk-021696f2":1,"chunk-03ed791c":1,"chunk-0816d20e":1,"chunk-0e70c4f8":1,"chunk-10183d5c":1,"chunk-11e637b6":1,"chunk-122bc93b":1,"chunk-175d3956":1,"chunk-1b84941c":1,"chunk-1dfa5721":1,"chunk-23442f2a":1,"chunk-23f9aae4":1,"chunk-25e27ac6":1,"chunk-26c145f0":1,"chunk-2b660376":1,"chunk-30a1950c":1,"chunk-1e8a24e3":1,"chunk-33948906":1,"chunk-22e15a92":1,"chunk-29ead52e":1,"chunk-556e24f2":1,"chunk-6a57fb6d":1,"chunk-61ecb1fa":1,"chunk-1ce107b4":1,"chunk-27d5a6f4":1,"chunk-2b45834c":1,"chunk-4ecfca70":1,"chunk-821ab42c":1,"chunk-912aa4b0":1,"chunk-64e8f8c2":1,"chunk-1178983b":1,"chunk-4b94edc6":1,"chunk-4b8d2f82":1,"chunk-570befd2":1,"chunk-2e6ed763":1,"chunk-33822cf5":1,"chunk-36bc9c7e":1,"chunk-39502733":1,"chunk-3e87b9ad":1,"chunk-40942cc8":1,"chunk-443eb714":1,"chunk-714e0516":1,"chunk-53355b94":1,"chunk-5a92c5c1":1,"chunk-5ebed730":1,"chunk-60120c54":1,"chunk-22b87df1":1,"chunk-623dae24":1,"chunk-63bc88b5":1,"chunk-8b4e4a0e":1,"chunk-a9b06d20":1,"chunk-d9543eb6":1,"chunk-642532fe":1,"chunk-d567a44a":1,"chunk-65e3d389":1,"chunk-67f85965":1,"chunk-69e2c8f8":1,"chunk-6a59411e":1,"chunk-73c44011":1,"chunk-74cd88aa":1,"chunk-76f8ab2e":1,"chunk-77db4ccd":1,"chunk-78b50f1e":1,"chunk-7b9b76fa":1,"chunk-9550f074":1,"chunk-d1054ad8":1,"chunk-a532b156":1,"chunk-a668716e":1,"chunk-b0813968":1,"chunk-c4f181c2":1,"chunk-07828839":1,"chunk-f69bd0d2":1,"chunk-fa1688fa":1,"chunk-fa8b5d3e":1,"chunk-2487f171":1,"chunk-6624d664":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-01491e7a":"5648740a","chunk-021696f2":"8a72cd40","chunk-03ed791c":"07187c5e","chunk-0816d20e":"a81bfca5","chunk-0c7b2c68":"31d6cfe0","chunk-0e70c4f8":"86b3894e","chunk-10183d5c":"6a809503","chunk-11e637b6":"50881934","chunk-122bc93b":"0886a3ec","chunk-175d3956":"96b24a5f","chunk-1b84941c":"a2aad21b","chunk-1dfa5721":"28c24f36","chunk-23442f2a":"a37d274b","chunk-23f9aae4":"ae80c24e","chunk-25e27ac6":"fac7ca08","chunk-26c145f0":"995c8cd8","chunk-2b660376":"2e8340e5","chunk-2d0c510d":"31d6cfe0","chunk-30a1950c":"c644e0ae","chunk-1e8a24e3":"9d9407b9","chunk-2d0b2b47":"31d6cfe0","chunk-33948906":"fbe79fa8","chunk-619d7aac":"31d6cfe0","chunk-22e15a92":"475e1178","chunk-29ead52e":"0aa2138a","chunk-556e24f2":"a1e629ab","chunk-6a57fb6d":"97053293","chunk-61ecb1fa":"092bc392","chunk-1ce107b4":"9b3bd2dc","chunk-27d5a6f4":"60f5f549","chunk-2b45834c":"2c81347b","chunk-4ecfca70":"d0c57967","chunk-821ab42c":"ac67678c","chunk-912aa4b0":"6275b9dc","chunk-64e8f8c2":"012d682d","chunk-7da8889c":"31d6cfe0","chunk-1178983b":"4b253bcd","chunk-4b94edc6":"d23051c0","chunk-4b8d2f82":"fc73785b","chunk-570befd2":"3a69ed0e","chunk-2d0c8206":"31d6cfe0","chunk-2d0e9702":"31d6cfe0","chunk-2d0e991a":"31d6cfe0","chunk-2d0f028e":"31d6cfe0","chunk-2d20e788":"31d6cfe0","chunk-2d2160f1":"31d6cfe0","chunk-2d229afb":"31d6cfe0","chunk-2e6ed763":"92d4ab9e","chunk-33822cf5":"8d3c9cfb","chunk-36bc9c7e":"bcebd232","chunk-39502733":"e202d755","chunk-3e87b9ad":"bd637e2d","chunk-40942cc8":"34c5d3fe","chunk-443eb714":"0403342f","chunk-4463fdfe":"31d6cfe0","chunk-714e0516":"d1ac2c69","chunk-53355b94":"8b46a351","chunk-5a92c5c1":"0886a3ec","chunk-5ebed730":"2c099a52","chunk-60120c54":"8a72cd40","chunk-22b87df1":"8825216f","chunk-623dae24":"c8cfa34a","chunk-63bc88b5":"7098d7bf","chunk-8b4e4a0e":"de989f6a","chunk-a9b06d20":"2fba676f","chunk-d9543eb6":"a2eb72b3","chunk-642532fe":"eaa22e5d","chunk-d567a44a":"82698ccf","chunk-65e3d389":"c978fb4a","chunk-67f85965":"1d20c1b7","chunk-69e2c8f8":"228a108f","chunk-6a59411e":"1dd8358e","chunk-2d0ae9a7":"31d6cfe0","chunk-73c44011":"fdff0fbc","chunk-74cd88aa":"0886a3ec","chunk-76f8ab2e":"8f37a07e","chunk-77db4ccd":"048aad50","chunk-78b50f1e":"7ed50ba2","chunk-7b9b76fa":"14972a5b","chunk-9550f074":"2d61bcd0","chunk-c9aabcc2":"31d6cfe0","chunk-d1054ad8":"7895acc1","chunk-a532b156":"4dec8ecb","chunk-a668716e":"e05219fe","chunk-b0813968":"aa0703ae","chunk-c4f181c2":"c978fb4a","chunk-07828839":"c3d7a95d","chunk-cf3b0bda":"31d6cfe0","chunk-f69bd0d2":"3197986e","chunk-fa1688fa":"d13c34be","chunk-fa8b5d3e":"c5081925","chunk-2487f171":"30706fd1","chunk-6624d664":"05f78818"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//cdnstatic.gamekee.com/wiki/4.0/pc/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["a949","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
